import moment from "moment";
import React from "react";

const ALNoteReport = ({ reportData, datesOfTheWeek }) => {
  const formatDate = (date) => {
    const dateMoment = moment(date);
    const day = dateMoment.format("dddd");
    const formatted = dateMoment.format("L");

    return `${day}: Date ${formatted}`;
  };

  const renderServices = (data, serviceDate) => {
    const servicesByDate = data[serviceDate];
    if (servicesByDate) {
      const skillCategories = [
        "Personal Hygiene",
        "House Keeping",
        "Meal Preparation",
        "Shopping",
        "Laundry",
        "Money Management",
        "Healthy Lifestyle",
        "Stress Management",
        "Use of Public Transportation",
        "Medication Management",
        "Behavior Education",
      ];

      const services = [];

      skillCategories.forEach((category) => {
        if (servicesByDate[category]) {
          servicesByDate[category].forEach((service) => {
            const startTime = moment(
              `${serviceDate}T${service.ServiceStartTime}`
            ).format("LT");
            const endTime = moment(
              `${serviceDate}T${service.ServiceEndTime}`
            ).format("LT");
            services.push(
              <React.Fragment key={service.RecordedServiceId}>
                <div className="row border border-2 border-dark">
                  <div className="col border-bottom border-dark mx-2 px-0 mb-2">
                    Skill Category: {category} | {service.UnitsForService}{" "}
                    {service.UnitsForService !== 1 ? "units" : "unit"}
                    <br />
                    {startTime} - {endTime}
                    <div className="d-flex mt-2 mb-2">
                      <b>Planned Intervention</b>
                      <span className="flex-fill">
                        : {service.PlannedIntervention}
                      </span>
                    </div>
                    <div className="d-flex mb-2">
                      <b>Intervention Completed</b>
                      <span className="flex-fill">
                        : {service.InterventionCompleted}
                      </span>
                    </div>
                    <div className="d-flex">
                      <b>Child's Progress</b>
                      <span className="flex-fill">
                        : {service.ChildsProgressText}
                      </span>
                    </div>
                    <div className="d-flex mb-2">
                      <b>Child's Response</b>
                      <span className="flex-fill">
                        : {service.ChildsResponse}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="row border border-2 border-top-0 border-dark">
                  <div className="col-8 border-end border-2 border-dark">
                    <div className="d-inline-block">
                      <span className="align-bottom">Child's Signature:</span>
                      <img
                        style={{
                          width: 225,
                          height: 100,
                        }}
                        src={service.SignatureImage}
                        alt="child's signature"
                      />
                    </div>
                  </div>
                  <div className="col">
                    Provider's Signature: {service.AssociatedUserName}
                  </div>
                </div>
                <div className="row border border-2 border-top-0 border-dark mb-2">
                  <div className="col-8 border-end border-2 border-dark">
                    Date: {moment(service.SubmittedDate).format("L")}
                  </div>
                  <div className="col">
                    Date: {moment(service.SubmittedDate).format("L")}
                  </div>
                </div>
              </React.Fragment>
            );
          });
        }
      });

      return services;
    }
  };

  return (
    <>
      {reportData ? (
        <div className="container-fluid">
          <div className="row mt-5 mb-2">
            <div className="col fw-bold text-center">
              (Describe specific activities performed when training and
              assisting a child to develop or maintain skills in the Basic
              Living Skill Categories and include how it relates to the child's
              treatment goals. Also include start and end times for each type of
              Basic Living Skills category documented on the grid.)
            </div>
          </div>
          {datesOfTheWeek.map((d) => (
            <div key={d} className="row mb-2">
              <div className="col">
                <div className="row">
                  <div className="col h5">{formatDate(d)}</div>
                </div>
                {renderServices(reportData, d)}
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default ALNoteReport;
